<template>
<div class="model-translations">
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="language" label="原文" width="120">
        <template v-slot="column">
          {{getLangLabel(column.row.language)}}
        </template>
      </el-table-column>
      <el-table-column v-for="(text, field) in fields" :key="field" :prop="field" :label="text">
        <template v-slot="column">
          <a href="#" @click.prevent.stop="handleShowPop($event, column)" :class="{trans: true, empty: !column.row[field]}">{{column.row[field]}}</a>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
  <el-popover ref="pop" placement="bottom" width="300" :reference="editElement">
    <el-input type="textarea" v-model="editText" :autosize="{minRows:2}" resize="none"></el-input>
    <div style="text-align: right; margin: 12px 0 0 0;">
      <el-button size="mini" type="text" @click="$refs.pop.doClose()">取消</el-button>
      <el-button type="primary" size="mini" @click="handleSubmit">确定</el-button>
    </div>
  </el-popover>
</div>
</template>

<script>

function fromModel(model) {
  return {id: model.id, text: model.text, language: model.language};
}
function toModel(data) {
  return {id: data.id, text: data.text, language: data.language};
}

const types = {
  word: {
    indexUrl: '/api/word/translation/index',
    updateUrl: '/api/word/translation/update',
    fromModel,
    toModel
  },
  sentence: {
    indexUrl: '/api/sentence/translation/index',
    updateUrl: '/api/sentence/translation/update',
    fromModel,
    toModel
  },
  exercise: {
    type: 'json',
    indexUrl: '/api/exercise/translation/index',
    updateUrl: '/api/exercise/translation/update',
    fromModel: (val) => val,
    toModel: (val) => val,
  }
}

const langMap = {
  'zh': '中文',
  'en': '英文',
  'ja': '日语',
  'ko': '韩语',
  'vi': '越南语',
  'th': '泰语',
  'ru': '俄罗斯语',
  'es': '西班牙语',
  'fr': '法语',
  'ar': '阿拉伯语',
  'ug': '维吾尔语',
  'de': "德语",
  'pt': "葡萄牙语",
  'it': "意大利语",
  'id': "印尼语",
};

export default {
  name: 'ModelTranslation',
  props: {
    type: String,
  },
  data() {
    return {
      dialogTitle: '翻译管理',
      dialogVisible: false,
      tableData: [],
      editText: '',
      editElement: null,
      editItem: null,
      editProp: null,
      fields: {text: '翻译'},
    }
  },
  methods: {
    show(id, opts = {}) {
      this.tableData = [];
      this.fetchData(id, opts);
      this.dialogTitle = opts.title || '翻译管理';
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    fetchData (id, opts = {}) {
      const config = types[this.type];
      this.$http.get(config.indexUrl, {
        params: {
          'filter[id]': id,
          page: 1,
          'per-page': 99,
        }
      }).then(res => {
        const langKeys = Object.keys(langMap);
        const sort = (a, b) => {
          const k1 = langKeys.indexOf(a.language);
          const k2 = langKeys.indexOf(b.language);
          return k1 - k2;
        };
        if (Array.isArray(res.data)) {
          this.fields = {text: opts.originText || '翻译'};
          this.tableData = res.data.map(config.fromModel).sort(sort);
        } else if(res.data.type === 'json') {
          this.fields = res.data.fields;
          this.tableData = res.data.data.sort(sort);
        }
      })
    },
    submitData(data) {
      const config = types[this.type];
      return this.$http.put(config.updateUrl, config.toModel(data)).then(res => {
        if (res.data) {
          Object.assign(data, config.fromModel(res.data));
        }
        this.$refs.pop.doClose()
        return data;
      })
    },
    getLangLabel(lang) {
      return langMap[lang] || lang;
    },
    showPop (event, col) {
      this.editItem = col.row
      this.editProp = col.column.property || 'text';
      if (col.row.editText) {
        this.editText = col.row.editText;
      } else {
        this.editText = col.row[this.editProp];
      }
      this.editElement = event.target
      this.$refs.pop.referenceElm = this.editElement
      this.$refs.pop.doShow()
      window.setTimeout(() => {
        this.$refs.pop.popperElm.querySelector('textarea').focus()
      }, 1)
    },
    handleShowPop (event, col) {
      if (this.$refs.pop.showPopper) {
        this.$refs.pop.handleBlur()
        window.setTimeout(() => {
          this.showPop(event, col)
        }, 300)
      } else {
        this.showPop(event, col)
      }
    },
    handleSubmit () {
      if (!this.editText) return
      const item = this.editItem
      const data = {
        id: item.id,
        language: item.language,
        text: this.editText,
        prop: this.editProp,
      };
      this.submitData(data).then(res => {
        Object.assign(item, res);
        console.dir({item, res});
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.model-translations {
  .trans{
    color: #606266 !important;
    text-decoration: none;
    white-space: pre-wrap;
    &:hover{
      text-decoration: underline;
    }
    &.empty{
      color: #E6A23C !important;
    }
  }
}
</style>